import { render, staticRenderFns } from "./memory_usage.vue?vue&type=template&id=6f0b91de&"
import script from "./memory_usage.vue?vue&type=script&lang=js&"
export * from "./memory_usage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "memory_usage.vue"
export default component.exports